module.exports = __webpack_public_path__ + "media/images/trash3-e6ba3dcd.png";